export interface IDetailsState {
  currentStep: number;
  isLoading: boolean;
}

export const initialState: IDetailsState = {
  isLoading: false,
  currentStep: 1,
};
